export default __webpack_public_path__ + "static/media/Banner.d252162a.jpeg";